
export const _buildingFilters = [
	{
		name: "Borough",
		show_name: true,
		default_name: 'All Boroughs',
		search_key: "borough",
		values: [
			{
				name: "All Boroughs",
				filter: "",
				dropdown_name: "All Boroughs",
				search_value: ""
			},
			{
				name: "Manhattan",
				filter: "manhattan",
				dropdown_name: "Manhattan",
				search_value: "manhattan",
			},
			{
				name: "Brooklyn",
				filter: "brooklyn",
				dropdown_name: "Brooklyn",
				search_value: "brooklyn",
			},
			{
				name: "Queens",
				filter: "queens",
				dropdown_name: "Queens",
				search_value: "queens",
			},
		]
	},
	{
		name: "Construction",
		show_name: true,
		search_key: "sales_start_date",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Move-in Ready",
				filter: "completed",
				dropdown_name: "Move-in Ready (Has CO/TCO)",
				search_value: "[NOW-25YEARS TO NOW] OR building_status:(resale) OR offering_verified_status:(\"sold out\")",
			},
			{
				name: "Under Construction",
				filter: "not-completed",
				dropdown_name: "Under Construction (No CO/TCO)",
				search_value: "[* TO NOW-25YEARS] AND -building_status:(resale) AND -offering_verified_status:(\"sold out\")",
			}
			
		]
	},
	{
		name: "Price / Sq Ft",
		show_name: true,
		search_key: "inventory_stats_listings_average_ppsf",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "< $750 PPSF ",
				filter: "less-than-750",
				dropdown_name: "Less than $750",
				search_value: "[100 TO 750]"
			},
			{
				name: "$750 to $1,000 PPSF",
				filter: "75-to-1000",
				dropdown_name: "$750 to $1,000",
				search_value: "[751 TO 1000]"
			},
			{
				name: "$1,000 to $1,500 PPSF",
				filter: "1000-to-1500",
				dropdown_name: "$1,000 to $1,500",
				search_value: "[1001 TO 1500]"
			},
			{
				name: "$1,500 to $2,000 PPSF",
				filter: "1500-to-2000",
				dropdown_name: "$1,500 to $2,000",
				search_value: "[1500 TO 2000]"
			},
			{
				name: "$2,000 to $2,500 PPSF",
				filter: "2000-to-2500",
				dropdown_name: "$2,000 to $2,500",
				search_value: "[2001 to 2500]"
			},
			{
				name: "$2,500 to $5,000 PPSF",
				filter: "2500-to-5000",
				dropdown_name: "$2,500 to $5,000",
				search_value: "[2501 to 5000]"
			},
			{
				name: "$5,000+ PPSF",
				filter: "5000-or-more",
				dropdown_name: "$5,000 or more",
				search_value: "[5001 TO *]"
			}
		]
	},
	{
		name: "Starting From",
		show_name: true,
		search_key: "inventory_stats_listings_low_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "From: < $500,000 ",
				filter: "less-than-500",
				dropdown_name: "Less than $500K",
				search_value: "[100 TO 500000]"
			},
			{
				name: "From: $500K to $750K",
				filter: "500-to-750",
				dropdown_name: "$500K to $750K",
				search_value: "[500000 TO 750000]"
			},
			{
				name: "From: $750K to $1M",
				filter: "750-to-1000",
				dropdown_name: "$750K to $1M",
				search_value: "[750001 TO 1000000]"
			},
			{
				name: "From: $1M to $1.5M",
				filter: "1000-to-1500",
				dropdown_name: "$1M to $1.5M",
				search_value: "[1000001 TO 1500000]"
			},
			{
				name: "From: $1.5M to $2M",
				filter: "1500-to-2000",
				dropdown_name: "$1.5M to $2M",
				search_value: "[1500001 TO 2000000]"
			},
			{
				name: "From: $2M+",
				filter: "2000+",
				dropdown_name: "$2M+",
				search_value: "[2000000 TO *]"
			}
		]
	},
	
	{
		name: "Unsold Units",
		show_name: true,
		search_key: "inventory_unsold",
		values: [
			{
				name: "Any Unsold Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-10 Unsold Units",
				filter: "1-to-10",
				dropdown_name: "1 to 10",
				search_value: "[1 TO 10]"
			},
			{
				name: "11-30 Unsold Units",
				filter: "11-to-30",
				dropdown_name: "11 to 30",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Unsold Units",
				filter: "31-to-50",
				dropdown_name: "31 to 50",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Unsold Units",
				filter: "51-to-100",
				dropdown_name: "51 to 100",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Unsold Units",
				filter: "101-to-200",
				dropdown_name: "101 to 200",
				search_value: "[101 TO 200]"
			},
			{
				name: "201 + Unsold Units",
				filter: "201-or-more",
				dropdown_name: "201 or more",
				search_value: "[201 TO *]"
			}
		]
	},
	{
		name: "% Sold",
		show_name: true,
		search_key: "inventory_pct_sold",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Has Sales",
				filter: "has-sales",
				dropdown_name: "Has Sales",
				search_value: "[1 TO *] OR offering_verified_status:\"sold out\""
			},
			{
				name: "Has No Sales",
				filter: "no-sales",
				dropdown_name: "Has No Sales",
				search_value: "[* TO 0] AND -offering_verified_status:\"sold out\""
			},
			{
				name: "Less Than 15%",
				filter: "0-to-15",
				dropdown_name: "Less Than 15%",
				search_value: "[0 TO 15]"
			},
			{
				name: "Less Than 35%",
				filter: "0-to-35",
				dropdown_name: "Less Than 35%",
				search_value: "[0 TO 34]"
			},
			{
				name: "Less Than 50%",
				filter: "0-to-49",
				dropdown_name: "Less Than 50%",
				search_value: "[0 TO 49]"
			},
			{
				name: "50% to 79%",
				filter: "50-to-79",
				dropdown_name: "50% to 79%",
				search_value: "[50 TO 79]"
			},
			{
				name: "80% to 99%",
				filter: "80-to-99",
				dropdown_name: "80% to 99%",
				search_value: "[80 TO 99]"
			},
			{
				name: "Sold Out",
				filter: "100 TO *",
				dropdown_name: "Sold Out",
				search_value: "[100 TO *]"
			},
			{
				name: "More Than 15%",
				filter: "15-to-100",
				dropdown_name: "More Than 15%",
				search_value: "[15 TO *]"
			},
			{
				name: "More Than 35%",
				filter: "35-to-100",
				dropdown_name: "More Than 35%",
				search_value: "[35 TO *]"
			},
			{
				name: "More Than 50%",
				filter: "50-to-100",
				dropdown_name: "More Than 50%",
				search_value: "[50 TO *]"
			},
		]
	},
	{
		name: "Total Units",
		show_name: true,
		search_key: "residential_units",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-10 Total Units",
				filter: "1-to-10",
				dropdown_name: "1 to 10 Units",
				search_value: "[1 TO 10]"
			},
			{
				name: "11-30 Total Units",
				filter: "11-to-30",
				dropdown_name: "11 to 30 Units",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Total Units",
				filter: "31-to-50",
				dropdown_name: "31 to 50 Units",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Total Units",
				filter: "51-to-100",
				dropdown_name: "51 to 100 Units",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Total Units",
				filter: "101-to-200",
				dropdown_name: "101 to 200 Units",
				search_value: "[101 TO 200]"
			},
			{
				name: "201-400 Total Units",
				filter: "201-to-400",
				dropdown_name: "201 to 400 Units",
				search_value: "[201 TO 400]"
			},
			{
				name: "401 + Total Units",
				filter: "401-or-more",
				dropdown_name: "401 or more Units",
				search_value: "[401 TO *]"
			}
		]
	},
	{
		name: "Offering Type",
		show_name: true,
		search_key: "offering_construction",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "New Construction",
				filter: "new-construction",
				dropdown_name: "New Construction",
				search_value: "new",
			},
			{
				name: "Conversion",
				filter: "conversion",
				dropdown_name: "Conversion",
				search_value: "conversion",
			},			
			{
				name: "Rehab",
				filter: "rehab",
				dropdown_name: "Rehab",
				search_value: "rehab",
			}
			
		]
	},
	{
		name: "Status",
		show_name: true,
		search_key: "offering_verified_status",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Vetted by Marketproof",
				filter: "vetted",
				dropdown_name: "Vetted by Marketproof",
				search_value: "active"
			},
			{
				name: "Vetting In Progress",
				filter: "in-progress",
				dropdown_name: "Vetting In Progress",
				search_value: "(\"coming soon\" \"offering plan required\" \"condo declaration vetted\")"
			}
		]
	},	
	{
		name: "Added",
		show_name: false,
		search_key: "offering_verified_active_date",
		values: [
			{
				name: "Any Time",
				filter: "",
				dropdown_name: "Any Time",
				search_value: ""
			},
			{
				name: "Recently Added",
				filter: "recently-added",
				dropdown_name: "Recenly Added",
				search_value: "[NOW-6MONTHS TO NOW]"
			}
		]
	},
];

export const _agentFilters = [
	{
		name: "Areas of Focus",
		show_name: true,
		default_name: 'Areas of Focus',
		search_key: "borough",
		values: [
			{
				name: "All Boroughs",
				filter: "",
				dropdown_name: "All Boroughs",
				search_value: ""
			},
			{
				name: "Manhattan",
				filter: "manhattan",
				dropdown_name: "Manhattan",
				search_value: "manhattan",
			},
			{
				name: "Brooklyn",
				filter: "brooklyn",
				dropdown_name: "Brooklyn",
				search_value: "brooklyn",
			},
			{
				name: "Queens",
				filter: "queens",
				dropdown_name: "Queens",
				search_value: "queens",
			},
			{
				name: "Bronx",
				filter: "bronx",
				dropdown_name: "Bronx",
				search_value: "bronx",
			},
			{
				name: "Staten Island",
				filter: "staten-island",
				dropdown_name: "Staten Island",
				search_value: "staten-island",
			},
		]
	},
	{
		name: "Property Focus",
		show_name: true,
		default_name: 'Property Focus',
		search_key: "borough",
		values: [
			{
				name: "All Types",
				filter: "",
				dropdown_name: "All Types",
				search_value: ""
			},
			{
				name: "Condos",
				filter: "condos",
				dropdown_name: "Condos",
				search_value: "condos",
			},
			{
				name: "Co-Ops",
				filter: "co-ops",
				dropdown_name: "Co-Ops",
				search_value: "co-ops",
			},
			{
				name: "Single Family",
				filter: "single-fam",
				dropdown_name: "Single Family",
				search_value: "single-fam",
			},
			{
				name: "Multi-Family",
				filter: "multi-fam",
				dropdown_name: "Bronx",
				search_value: "multi-fam",
			}
		]
	},
	{
		name: "Buy-Side Transactions",
		show_name: true,
		search_key: "sold_units",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-10 Sales",
				filter: "1-to-10",
				dropdown_name: "1 to 10 Sales",
				search_value: "[1 TO 10]"
			},
			{
				name: "11-30 Sales",
				filter: "11-to-30",
				dropdown_name: "11 to 30 Sales",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Sales",
				filter: "31-to-50",
				dropdown_name: "31 to 50 Sales",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Sales",
				filter: "51-to-100",
				dropdown_name: "51 to 100 Sales",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Sales",
				filter: "101-to-200",
				dropdown_name: "101 to 200 Sales",
				search_value: "[101 TO 200]"
			},
			{
				name: "201-400 Sales",
				filter: "201-to-400",
				dropdown_name: "201 to 400 Sales",
				search_value: "[201 TO 400]"
			},
			{
				name: "401 + Sales",
				filter: "401-or-more",
				dropdown_name: "401 or more Units",
				search_value: "[401 TO *]"
			}
		]
	},
	{
		name: "Buy-Side $ Volume",
		show_name: true,
		search_key: "offering_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Less Than $5M",
				filter: "less-than-5000",
				dropdown_name: "Less Than $5M",
				search_value: ""
			},
			{
				name: "$5M to $10M",
				filter: "1000-to-1000",
				dropdown_name: "$5M to $10M",
				search_value: "[1000000 TO 1999999] OR last_sold_price:[1000000 TO 1999999] OR last_listed_sale_price_all:[1000000 TO 1999999]"
			},
	
			{
				name: "$10M to $20M",
				filter: "1000-to-1000",
				dropdown_name: "$10M to $20M",
				search_value: "[1000000 TO 1999999] OR last_sold_price:[1000000 TO 1999999] OR last_listed_sale_price_all:[1000000 TO 1999999]"
			},
			{
				name: "$20M to $30M",
				filter: "2000-to-3000",
				dropdown_name: "$20M to $30M",
				search_value: "[2000000 TO 2999999] OR last_sold_price:[2000000 TO 2999999] OR last_listed_sale_price_all:[2000000 TO 2999999]"
			},			{
				name: "$30M to $40M",
				filter: "3000-to-4000",
				dropdown_name: "$30M to $40M",
				search_value: "[3000000 TO 3999999] OR last_sold_price:[3000000 TO 3999999] OR last_listed_sale_price_all:[3000000 TO 3999999]"
			},
			{
				name: "$40M to $50M",
				filter: "4000-to-5000",
				dropdown_name: "$40M to $50M",
				search_value: "[4000000 TO 4999999] OR last_sold_price:[4000000 TO 4999999] OR last_listed_sale_price_all:[4000000 TO 4999999]"
			},
			{
				name: "$50M to $100M",
				filter: "4000-to-5000",
				dropdown_name: "$50M to $100M",
				search_value: "[4000000 TO 4999999] OR last_sold_price:[4000000 TO 4999999] OR last_listed_sale_price_all:[4000000 TO 4999999]"
			},
	
			{
				name: "$100M+",
				filter: "10000-or-more",
				dropdown_name: "$100M+",
				search_value: "[5000001 TO *] OR last_sold_price:[5000001 TO *] OR last_listed_sale_price_all:[5000001 TO *]"
			}
		]
	},
	{
		name: "Sell-Side Transactions",
		show_name: true,
		search_key: "sold_units",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-10 Sales",
				filter: "1-to-10",
				dropdown_name: "1 to 10 Sales",
				search_value: "[1 TO 10]"
			},
			{
				name: "11-30 Sales",
				filter: "11-to-30",
				dropdown_name: "11 to 30 Sales",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Sales",
				filter: "31-to-50",
				dropdown_name: "31 to 50 Sales",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Sales",
				filter: "51-to-100",
				dropdown_name: "51 to 100 Sales",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Sales",
				filter: "101-to-200",
				dropdown_name: "101 to 200 Sales",
				search_value: "[101 TO 200]"
			},
			{
				name: "201-400 Sales",
				filter: "201-to-400",
				dropdown_name: "201 to 400 Sales",
				search_value: "[201 TO 400]"
			},
			{
				name: "401 + Sales",
				filter: "401-or-more",
				dropdown_name: "401 or more Units",
				search_value: "[401 TO *]"
			}
		]
	},
	{
		name: "Sell-Side $ Volume",
		show_name: true,
		search_key: "offering_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Less Than $5M",
				filter: "less-than-5000",
				dropdown_name: "Less Than $5M",
				search_value: ""
			},
			{
				name: "$5M to $10M",
				filter: "1000-to-1000",
				dropdown_name: "$5M to $10M",
				search_value: "[1000000 TO 1999999] OR last_sold_price:[1000000 TO 1999999] OR last_listed_sale_price_all:[1000000 TO 1999999]"
			},

			{
				name: "$10M to $20M",
				filter: "1000-to-1000",
				dropdown_name: "$10M to $20M",
				search_value: "[1000000 TO 1999999] OR last_sold_price:[1000000 TO 1999999] OR last_listed_sale_price_all:[1000000 TO 1999999]"
			},
			{
				name: "$20M to $30M",
				filter: "2000-to-3000",
				dropdown_name: "$20M to $30M",
				search_value: "[2000000 TO 2999999] OR last_sold_price:[2000000 TO 2999999] OR last_listed_sale_price_all:[2000000 TO 2999999]"
			},			{
				name: "$30M to $40M",
				filter: "3000-to-4000",
				dropdown_name: "$30M to $40M",
				search_value: "[3000000 TO 3999999] OR last_sold_price:[3000000 TO 3999999] OR last_listed_sale_price_all:[3000000 TO 3999999]"
			},
			{
				name: "$40M to $50M",
				filter: "4000-to-5000",
				dropdown_name: "$40M to $50M",
				search_value: "[4000000 TO 4999999] OR last_sold_price:[4000000 TO 4999999] OR last_listed_sale_price_all:[4000000 TO 4999999]"
			},
			{
				name: "$50M to $100M",
				filter: "4000-to-5000",
				dropdown_name: "$50M to $100M",
				search_value: "[4000000 TO 4999999] OR last_sold_price:[4000000 TO 4999999] OR last_listed_sale_price_all:[4000000 TO 4999999]"
			},

			{
				name: "$100M+",
				filter: "10000-or-more",
				dropdown_name: "$100M+",
				search_value: "[5000001 TO *] OR last_sold_price:[5000001 TO *] OR last_listed_sale_price_all:[5000001 TO *]"
			}
		]
	},
	
]

export const _unitFilters = [
	{
		name: "Borough",
		show_name: true,
		search_key: "borough",
		default_name: 'All Boroughs',
		building_hide: true,
		values: [
			{
				name: "All Boroughs",
				filter: "",
				dropdown_name: "All Boroughs",
				search_value: ""
			},
			{
				name: "Manhattan",
				filter: "manhattan",
				dropdown_name: "Manhattan",
				search_value: "manhattan",
			},
			{
				name: "Brooklyn",
				filter: "brooklyn",
				dropdown_name: "Brooklyn",
				search_value: "brooklyn",
			},
			{
				name: "Queens",
				filter: "queens",
				dropdown_name: "Queens",
				search_value: "queens",
			},
			{
				name: "Bronx",
				filter: "bronx",
				dropdown_name: "Bronx",
				search_value: "bronx",
			},
			{
				name: "Staten Island",
				filter: "staten-island",
				dropdown_name: "Staten Island",
				search_value: "staten-island",
			},

		]
	},
	{
		name: "Property Type",
		show_name: true,
		default_name: 'Property Type',
		search_key: "borough",
		values: [
			{
				name: "All Types",
				filter: "",
				dropdown_name: "All Types",
				search_value: ""
			},
			{
				name: "Condos",
				filter: "condos",
				dropdown_name: "Condos",
				search_value: "condos",
			},
			{
				name: "Co-Ops",
				filter: "co-ops",
				dropdown_name: "Co-Ops",
				search_value: "co-ops",
			},
			{
				name: "Single Family",
				filter: "single-fam",
				dropdown_name: "Single Family",
				search_value: "single-fam",
			},
			{
				name: "Multi-Family",
				filter: "multi-fam",
				dropdown_name: "Bronx",
				search_value: "multi-fam",
			}
		]
	},
	{
		name: "Price",
		show_name: true,
		search_key: "offering_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Less Than $1M",
				filter: "less-than-1000",
				dropdown_name: "Less Than $1M",
				search_value: "[100 TO 999999] OR last_sold_price:[100 TO 999999] OR last_listed_sale_price_all:[100 TO 999999]"
			},
			{
				name: "$1M to $2M",
				filter: "1000-to-1000",
				dropdown_name: "$1M to $2M",
				search_value: "[1000000 TO 1999999] OR last_sold_price:[1000000 TO 1999999] OR last_listed_sale_price_all:[1000000 TO 1999999]"
			},
			{
				name: "$2M to $3M",
				filter: "2000-to-3000",
				dropdown_name: "$2M to $3M",
				search_value: "[2000000 TO 2999999] OR last_sold_price:[2000000 TO 2999999] OR last_listed_sale_price_all:[2000000 TO 2999999]"
			},			{
				name: "$3M to $4M",
				filter: "3000-to-4000",
				dropdown_name: "$3M to $4M",
				search_value: "[3000000 TO 3999999] OR last_sold_price:[3000000 TO 3999999] OR last_listed_sale_price_all:[3000000 TO 3999999]"
			},
			{
				name: "$4M to $5M",
				filter: "4000-to-5000",
				dropdown_name: "$4M to $5M",
				search_value: "[4000000 TO 4999999] OR last_sold_price:[4000000 TO 4999999] OR last_listed_sale_price_all:[4000000 TO 4999999]"
			},
			{
				name: "$5M+",
				filter: "5000-or-more",
				dropdown_name: "$5M+",
				search_value: "[5000001 TO *] OR last_sold_price:[5000001 TO *] OR last_listed_sale_price_all:[5000001 TO *]"
			}
		]
	},
	{
		name: "Bedrooms",
		show_name: true,
		search_key: "offering_bedrooms",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Studio",
				filter: "studio",
				dropdown_name: "Studio",
				search_value: "0 OR bedrooms:0",
			},
			{
				name: "1 Bedroom",
				filter: "1-bedroom",
				dropdown_name: "1 Bedroom",
				search_value: "1 OR bedrooms:1",
			},
			{
				name: "2 Bedroom",
				filter: "2-bedroom",
				dropdown_name: "2 Bedroom",
				search_value: "2 OR bedrooms:2",
			},
			{
				name: "3 Bedroom",
				filter: "3-bedroom",
				dropdown_name: "3 Bedroom",
				search_value: "3 OR bedrooms:3",
			},
			{
				name: "4+ Bedroom",
				filter: "4-or-more",
				dropdown_name: "4+ Bedroom",
				search_value: "[4 TO *] OR bedrooms:[4 TO *]",
			},
		]
	},
	{
		name: "Baths",
		show_name: true,
		search_key: "offering_baths",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},			
			{
				name: "1 Bath",
				filter: "1-bath",
				dropdown_name: "1 Bath",
				search_value: "1 OR baths:1",
			},
			{
				name: "2 Bath",
				filter: "2-bath",
				dropdown_name: "2 Bath",
				search_value: "2 OR baths:2",
			},
			{
				name: "3 Bath",
				filter: "3-bath",
				dropdown_name: "3 Bath",
				search_value: "3 OR baths:3",
			},
			{
				name: "4+ Bath",
				filter: "4-or-more",
				dropdown_name: "4+ Bath",
				search_value: "[4 TO *] OR baths:[4 TO *]",
			},
		]
	},
	{
		name: "Interior SF",
		show_name: true,
		search_key: "offering_sq_ft",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "< 500 ",
				filter: "less-than-500",
				dropdown_name: "Less than $500K",
				search_value: "[10 TO 500] OR sq_ft:[10 TO 500] "
			},
			{
				name: "501 to 750 SF",
				filter: "501-to-750",
				dropdown_name: "501 to 750 SF",
				search_value: "[501 TO 750] OR sq_ft:[501 TO 750] "
			},
			{
				name: "751 to 1,000 SF",
				filter: "751-to-1000",
				dropdown_name: "751 to 1000 SF",
				search_value: "[751 TO 1000] OR sq_ft:[751 TO 1000]"
			},
			{
				name: "1,001 to 1,500 SF",
				filter: "1001-to-1500",
				dropdown_name: "1,001 to 1,500 SF",
				search_value: "[1001 TO 1500] OR sq_ft:[1001 TO 1500]"
			},
			{
				name: "1,501 to 2,000 SF",
				filter: "1501-to-2000",
				dropdown_name: "1,501 to 2,000 SF",
				search_value: "[1501 TO 2000] OR sq_ft:[1501 TO 2000]"
			},
			{
				name: "2,001 to 3,000 SF",
				filter: "2001-to-3000",
				dropdown_name: "2,001 to 3,000 SF",
				search_value: "[2001 TO 3000] OR sq_ft:[2001 TO 3000]"
			},
			{
				name: "3,000+ SF",
				filter: "3001-or-more",
				dropdown_name: "More than 3000 SF",
				search_value: "[3001 TO *] OR sq_ft:[3001 TO *]"
			}
		]
	},
	{
		name: "Exterior SF",
		show_name: true,
		search_key: "offering_exterior_sq_ft",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Has Exterior SF",
				filter: "has-exterior-sf",
				dropdown_name: "Has Exterior SF",
				search_value: "[1 TO *]"
			},
			{
				name: "No Exterior SF",
				filter: "no-exterior-sf",
				dropdown_name: "No Exterior SF",
				search_value: "[* TO 0]"
			},
			{
				name: "< 50 ",
				filter: "less-than-50",
				dropdown_name: "Less than 50 SF",
				search_value: "[0 TO 50]"
			},
			{
				name: "50 to 100 SF",
				filter: "50-to-100",
				dropdown_name: "50 to 100 SF",
				search_value: "[51 TO 100]"
			},
			{
				name: "101 to 200 SF",
				filter: "100-to-200",
				dropdown_name: "101 to 200 SF",
				search_value: "[101 TO 200]"
			},
			{
				name: "201 to 500 SF",
				filter: "200-to-500",
				dropdown_name: "201 to 500 SF",
				search_value: "[201 TO 500]"
			},			
			{
				name: "500+ SF",
				filter: "500-more",
				dropdown_name: "More than 500 SF",
				search_value: "[501 TO *]"
			}
		]
	}
	
];


export const _lendingFilters = [
	{
		name: "Property Type",
		show_name: true,
		default_name: 'Property Type',
		search_key: "borough",
		values: [
			{
				name: "All Types",
				filter: "",
				dropdown_name: "All Types",
				search_value: ""
			},
			{
				name: "Condos",
				filter: "condos",
				dropdown_name: "Condos",
				search_value: "condos",
			},
			{
				name: "Co-Ops",
				filter: "co-ops",
				dropdown_name: "Co-Ops",
				search_value: "co-ops",
			},
			{
				name: "Single Family",
				filter: "single-fam",
				dropdown_name: "Single Family",
				search_value: "single-fam",
			},
			{
				name: "Multi-Family",
				filter: "multi-fam",
				dropdown_name: "Bronx",
				search_value: "multi-fam",
			}
		]
	},
	
	{
		name: "Property Value",
		show_name: true,
		search_key: "offering_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Less Than $1M",
				filter: "less-than-1000",
				dropdown_name: "Less Than $1M",
				search_value: "[100 TO 999999] OR last_sold_price:[100 TO 999999] OR last_listed_sale_price_all:[100 TO 999999]"
			},
			{
				name: "$1M to $2M",
				filter: "1000-to-1000",
				dropdown_name: "$1M to $2M",
				search_value: "[1000000 TO 1999999] OR last_sold_price:[1000000 TO 1999999] OR last_listed_sale_price_all:[1000000 TO 1999999]"
			},
			{
				name: "$2M to $3M",
				filter: "2000-to-3000",
				dropdown_name: "$2M to $3M",
				search_value: "[2000000 TO 2999999] OR last_sold_price:[2000000 TO 2999999] OR last_listed_sale_price_all:[2000000 TO 2999999]"
			},			{
				name: "$3M to $4M",
				filter: "3000-to-4000",
				dropdown_name: "$3M to $4M",
				search_value: "[3000000 TO 3999999] OR last_sold_price:[3000000 TO 3999999] OR last_listed_sale_price_all:[3000000 TO 3999999]"
			},
			{
				name: "$4M to $5M",
				filter: "4000-to-5000",
				dropdown_name: "$4M to $5M",
				search_value: "[4000000 TO 4999999] OR last_sold_price:[4000000 TO 4999999] OR last_listed_sale_price_all:[4000000 TO 4999999]"
			},
			{
				name: "$5M+",
				filter: "5000-or-more",
				dropdown_name: "$5M+",
				search_value: "[5000001 TO *] OR last_sold_price:[5000001 TO *] OR last_listed_sale_price_all:[5000001 TO *]"
			}
		]
	},
	{
		name: "Bedrooms",
		show_name: true,
		search_key: "offering_bedrooms",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Studio",
				filter: "studio",
				dropdown_name: "Studio",
				search_value: "0 OR bedrooms:0",
			},
			{
				name: "1 Bedroom",
				filter: "1-bedroom",
				dropdown_name: "1 Bedroom",
				search_value: "1 OR bedrooms:1",
			},
			{
				name: "2 Bedroom",
				filter: "2-bedroom",
				dropdown_name: "2 Bedroom",
				search_value: "2 OR bedrooms:2",
			},
			{
				name: "3 Bedroom",
				filter: "3-bedroom",
				dropdown_name: "3 Bedroom",
				search_value: "3 OR bedrooms:3",
			},
			{
				name: "4+ Bedroom",
				filter: "4-or-more",
				dropdown_name: "4+ Bedroom",
				search_value: "[4 TO *] OR bedrooms:[4 TO *]",
			},
		]
	},
	{
		name: "Baths",
		show_name: true,
		search_key: "offering_baths",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},			
			{
				name: "1 Bath",
				filter: "1-bath",
				dropdown_name: "1 Bath",
				search_value: "1 OR baths:1",
			},
			{
				name: "2 Bath",
				filter: "2-bath",
				dropdown_name: "2 Bath",
				search_value: "2 OR baths:2",
			},
			{
				name: "3 Bath",
				filter: "3-bath",
				dropdown_name: "3 Bath",
				search_value: "3 OR baths:3",
			},
			{
				name: "4+ Bath",
				filter: "4-or-more",
				dropdown_name: "4+ Bath",
				search_value: "[4 TO *] OR baths:[4 TO *]",
			},
		]
	},
	{
		name: "Interior SF",
		show_name: true,
		search_key: "offering_sq_ft",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "< 500 ",
				filter: "less-than-500",
				dropdown_name: "Less than 500 SF",
				search_value: "[10 TO 500] OR sq_ft:[10 TO 500] "
			},
			{
				name: "501 to 750 SF",
				filter: "501-to-750",
				dropdown_name: "501 to 750 SF",
				search_value: "[501 TO 750] OR sq_ft:[501 TO 750] "
			},
			{
				name: "751 to 1,000 SF",
				filter: "751-to-1000",
				dropdown_name: "751 to 1000 SF",
				search_value: "[751 TO 1000] OR sq_ft:[751 TO 1000]"
			},
			{
				name: "1,001 to 1,500 SF",
				filter: "1001-to-1500",
				dropdown_name: "1,001 to 1,500 SF",
				search_value: "[1001 TO 1500] OR sq_ft:[1001 TO 1500]"
			},
			{
				name: "1,501 to 2,000 SF",
				filter: "1501-to-2000",
				dropdown_name: "1,501 to 2,000 SF",
				search_value: "[1501 TO 2000] OR sq_ft:[1501 TO 2000]"
			},
			{
				name: "2,001 to 3,000 SF",
				filter: "2001-to-3000",
				dropdown_name: "2,001 to 3,000 SF",
				search_value: "[2001 TO 3000] OR sq_ft:[2001 TO 3000]"
			},
			{
				name: "3,000+ SF",
				filter: "3001-or-more",
				dropdown_name: "More than 3000 SF",
				search_value: "[3001 TO *] OR sq_ft:[3001 TO *]"
			}
		]
	},
	{
		name: "Exterior SF",
		show_name: true,
		search_key: "offering_exterior_sq_ft",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Has Exterior SF",
				filter: "has-exterior-sf",
				dropdown_name: "Has Exterior SF",
				search_value: "[1 TO *]"
			},
			{
				name: "No Exterior SF",
				filter: "no-exterior-sf",
				dropdown_name: "No Exterior SF",
				search_value: "[* TO 0]"
			},
			{
				name: "< 50 ",
				filter: "less-than-50",
				dropdown_name: "Less than 50 SF",
				search_value: "[0 TO 50]"
			},
			{
				name: "50 to 100 SF",
				filter: "50-to-100",
				dropdown_name: "50 to 100 SF",
				search_value: "[51 TO 100]"
			},
			{
				name: "101 to 200 SF",
				filter: "100-to-200",
				dropdown_name: "101 to 200 SF",
				search_value: "[101 TO 200]"
			},
			{
				name: "201 to 500 SF",
				filter: "200-to-500",
				dropdown_name: "201 to 500 SF",
				search_value: "[201 TO 500]"
			},			
			{
				name: "500+ SF",
				filter: "500-more",
				dropdown_name: "More than 500 SF",
				search_value: "[501 TO *]"
			}
		]
	},
	{
		name: "Carrying Cost",
		show_name: true,
		search_key: "offering_monthly_carrying_charges",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "< $1,000",
				filter: "less-than-1000",
				dropdown_name: "Less than $1000",
				search_value: "[0 TO 1000] OR monthly_fees:[0 TO 1000]"
			},
			{
				name: "$1,000 to $1,500",
				filter: "1001-to-1501",
				dropdown_name: "$1,000 to $1,500",
				search_value: "[1001 TO 1500] OR monthly_fees:[1001 TO 1500]"
			},
			{
				name: "$1,500 to $2,000",
				filter: "1501-to-2001",
				dropdown_name: "$1,500 to $2,000",
				search_value: "[1501 TO 2000] OR monthly_fees:[1501 TO 2000]"
			},
			{
				name: "$2,000 to $3,000",
				filter: "2001-to-3001",
				dropdown_name: "$2,000 to $3,000",
				search_value: "[2001 TO 3000] OR monthly_fees:[2001 TO 3000]"
			},
			{
				name: "$3,000 to $5,000",
				filter: "3,000-to-5000",
				dropdown_name: "$3,000 to $5,000",
				search_value: "[3001 TO 5000] OR monthly_fees:[3001 TO 5000]"
			},
			{
				name: "$5,000+",
				filter: "5000-or-more",
				dropdown_name: "$5,000 or more",
				search_value: "[5001 TO *] OR monthly_fees:[5001 TO *]"
			}
		]
	}
	
];

export const _latestLoanFilters = [
	{
		name: "Borough",
		show_name: true,
		default_name: 'All Boroughs',
		search_key: "borough",
		values: [
			{
				name: "All Boroughs",
				filter: "",
				dropdown_name: "All Boroughs",
				search_value: ""
			},
			{
				name: "Manhattan",
				filter: "manhattan",
				dropdown_name: "Manhattan",
				search_value: "manhattan",
			},
			{
				name: "Brooklyn",
				filter: "brooklyn",
				dropdown_name: "Brooklyn",
				search_value: "brooklyn",
			},
			{
				name: "Queens",
				filter: "queens",
				dropdown_name: "Queens",
				search_value: "queens",
			},
			{
				name: "Bronx",
				filter: "bronx",
				dropdown_name: "Bronx",
				search_value: "bronx",
			},
			{
				name: "Staten Island",
				filter: "staten-island",
				dropdown_name: "Staten Island",
				search_value: "staten-island",
			},
		]
	},
	/*{
		name: "Lender",
		show_name: true,
		default_name: 'All Lenders',
		search_key: "lender",
		values: [
			{
				name: "All Lenders",
				filter: "",
				dropdown_name: "All Lenders",
				search_value: ""
			},
			{
				name: "JP Morgan Chase",
				filter: "chase",
				dropdown_name: "JP Morgan Chase",
				search_value: "chase",
			},
			{
				name: "Wells Fargo",
				filter: "wells",
				dropdown_name: "Wells Fargo",
				search_value: "wells",
			},
			{
				name: "Citizens",
				filter: "citizens",
				dropdown_name: "Citizens",
				search_value: "citizens",
			},
			{
				name: "TD Bank",
				filter: "td",
				dropdown_name: "TD Bank",
				search_value: "td",
			},
			{
				name: "First Republic",
				filter: "frb",
				dropdown_name: "First Republic",
				search_value: "frb",
			},
		]
	},*/
	{
		name: "Loan-to-Value (LTV)",
		show_name: true,
		search_key: "inventory_pct_sold",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Less Than 25%",
				filter: "0-to-25",
				dropdown_name: "Less Than 25%",
				search_value: "[0 TO 25]"
			},
			{
				name: "25% to 50%",
				filter: "25-to-50",
				dropdown_name: "25% to 50%",
				search_value: "[50 TO 79]"
			},
			{
				name: "50% to 79%",
				filter: "50-to-79",
				dropdown_name: "50% to 79%",
				search_value: "[50 TO 79]"
			},
			{
				name: "80% to 99%",
				filter: "80-to-99",
				dropdown_name: "80% to 99%",
				search_value: "[80 TO 99]"
			}
		]
	},
	{
		name: "Loan Amount",
		show_name: true,
		search_key: "loan_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Less Than $1M",
				filter: "less-than-1000",
				dropdown_name: "Less Than $1M",
				search_value: "[100 TO 999999] OR last_sold_price:[100 TO 999999] OR last_listed_sale_price_all:[100 TO 999999]"
			},
			{
				name: "$1M to $2M",
				filter: "1000-to-1000",
				dropdown_name: "$1M to $2M",
				search_value: "[1000000 TO 1999999] OR last_sold_price:[1000000 TO 1999999] OR last_listed_sale_price_all:[1000000 TO 1999999]"
			},
			{
				name: "$2M to $3M",
				filter: "2000-to-3000",
				dropdown_name: "$2M to $3M",
				search_value: "[2000000 TO 2999999] OR last_sold_price:[2000000 TO 2999999] OR last_listed_sale_price_all:[2000000 TO 2999999]"
			},			{
				name: "$3M to $4M",
				filter: "3000-to-4000",
				dropdown_name: "$3M to $4M",
				search_value: "[3000000 TO 3999999] OR last_sold_price:[3000000 TO 3999999] OR last_listed_sale_price_all:[3000000 TO 3999999]"
			},
			{
				name: "$4M to $5M",
				filter: "4000-to-5000",
				dropdown_name: "$4M to $5M",
				search_value: "[4000000 TO 4999999] OR last_sold_price:[4000000 TO 4999999] OR last_listed_sale_price_all:[4000000 TO 4999999]"
			},
			{
				name: "$5M+",
				filter: "5000-or-more",
				dropdown_name: "$5M+",
				search_value: "[5000001 TO *] OR last_sold_price:[5000001 TO *] OR last_listed_sale_price_all:[5000001 TO *]"
			}
		]
	},
	{
		name: "Property Value",
		show_name: true,
		search_key: "offering_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Less Than $1M",
				filter: "less-than-1000",
				dropdown_name: "Less Than $1M",
				search_value: "[100 TO 999999] OR last_sold_price:[100 TO 999999] OR last_listed_sale_price_all:[100 TO 999999]"
			},
			{
				name: "$1M to $2M",
				filter: "1000-to-1000",
				dropdown_name: "$1M to $2M",
				search_value: "[1000000 TO 1999999] OR last_sold_price:[1000000 TO 1999999] OR last_listed_sale_price_all:[1000000 TO 1999999]"
			},
			{
				name: "$2M to $3M",
				filter: "2000-to-3000",
				dropdown_name: "$2M to $3M",
				search_value: "[2000000 TO 2999999] OR last_sold_price:[2000000 TO 2999999] OR last_listed_sale_price_all:[2000000 TO 2999999]"
			},			{
				name: "$3M to $4M",
				filter: "3000-to-4000",
				dropdown_name: "$3M to $4M",
				search_value: "[3000000 TO 3999999] OR last_sold_price:[3000000 TO 3999999] OR last_listed_sale_price_all:[3000000 TO 3999999]"
			},
			{
				name: "$4M to $5M",
				filter: "4000-to-5000",
				dropdown_name: "$4M to $5M",
				search_value: "[4000000 TO 4999999] OR last_sold_price:[4000000 TO 4999999] OR last_listed_sale_price_all:[4000000 TO 4999999]"
			},
			{
				name: "$5M+",
				filter: "5000-or-more",
				dropdown_name: "$5M+",
				search_value: "[5000001 TO *] OR last_sold_price:[5000001 TO *] OR last_listed_sale_price_all:[5000001 TO *]"
			}
		]
	}
]

export const _refiFilters = [
	{
		name: "Borough",
		show_name: true,
		default_name: 'All Boroughs',
		search_key: "borough",
		values: [
			{
				name: "All Boroughs",
				filter: "",
				dropdown_name: "All Boroughs",
				search_value: ""
			},
			{
				name: "Manhattan",
				filter: "manhattan",
				dropdown_name: "Manhattan",
				search_value: "manhattan",
			},
			{
				name: "Brooklyn",
				filter: "brooklyn",
				dropdown_name: "Brooklyn",
				search_value: "brooklyn",
			},
			{
				name: "Queens",
				filter: "queens",
				dropdown_name: "Queens",
				search_value: "queens",
			},
			{
				name: "Bronx",
				filter: "bronx",
				dropdown_name: "Bronx",
				search_value: "bronx",
			},
			{
				name: "Staten Island",
				filter: "staten-island",
				dropdown_name: "Staten Island",
				search_value: "staten-island",
			},
		]
	},
	{
		name: "Property Type",
		show_name: true,
		default_name: 'Property Type',
		search_key: "borough",
		values: [
			{
				name: "All Types",
				filter: "",
				dropdown_name: "All Types",
				search_value: ""
			},
			{
				name: "Condos",
				filter: "condos",
				dropdown_name: "Condos",
				search_value: "condos",
			},
			{
				name: "Co-Ops",
				filter: "co-ops",
				dropdown_name: "Co-Ops",
				search_value: "co-ops",
			},
			{
				name: "Single Family",
				filter: "single-fam",
				dropdown_name: "Single Family",
				search_value: "single-fam",
			},
			{
				name: "Multi-Family",
				filter: "multi-fam",
				dropdown_name: "Bronx",
				search_value: "multi-fam",
			}
		]
	},
	{
		name: "Bedrooms",
		show_name: true,
		search_key: "offering_bedrooms",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Studio",
				filter: "studio",
				dropdown_name: "Studio",
				search_value: "0 OR bedrooms:0",
			},
			{
				name: "1 Bedroom",
				filter: "1-bedroom",
				dropdown_name: "1 Bedroom",
				search_value: "1 OR bedrooms:1",
			},
			{
				name: "2 Bedroom",
				filter: "2-bedroom",
				dropdown_name: "2 Bedroom",
				search_value: "2 OR bedrooms:2",
			},
			{
				name: "3 Bedroom",
				filter: "3-bedroom",
				dropdown_name: "3 Bedroom",
				search_value: "3 OR bedrooms:3",
			},
			{
				name: "4+ Bedroom",
				filter: "4-or-more",
				dropdown_name: "4+ Bedroom",
				search_value: "[4 TO *] OR bedrooms:[4 TO *]",
			},
		]
	},

	{
		name: "Lender",
		show_name: true,
		default_name: 'All Lenders',
		search_key: "lender",
		values: [
			{
				name: "All Lenders",
				filter: "",
				dropdown_name: "All Lenders",
				search_value: ""
			},
			{
				name: "JP Morgan Chase",
				filter: "chase",
				dropdown_name: "JP Morgan Chase",
				search_value: "chase",
			},
			{
				name: "Wells Fargo",
				filter: "wells",
				dropdown_name: "Wells Fargo",
				search_value: "wells",
			},
			{
				name: "Citizens",
				filter: "citizens",
				dropdown_name: "Citizens",
				search_value: "citizens",
			},
			{
				name: "TD Bank",
				filter: "td",
				dropdown_name: "TD Bank",
				search_value: "td",
			},
			{
				name: "First Republic",
				filter: "frb",
				dropdown_name: "First Republic",
				search_value: "frb",
			},
		]
	},
	{
		name: "Loan-to-Value",
		show_name: true,
		search_key: "inventory_pct_sold",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Less Than 25%",
				filter: "0-to-25",
				dropdown_name: "Less Than 25%",
				search_value: "[0 TO 25]"
			},
			{
				name: "25% to 50%",
				filter: "25-to-50",
				dropdown_name: "25% to 50%",
				search_value: "[50 TO 79]"
			},
			{
				name: "50% to 79%",
				filter: "50-to-79",
				dropdown_name: "50% to 79%",
				search_value: "[50 TO 79]"
			},
			{
				name: "80% to 99%",
				filter: "80-to-99",
				dropdown_name: "80% to 99%",
				search_value: "[80 TO 99]"
			}
		]
	},
	{
		name: "Sold Amount",
		show_name: true,
		search_key: "loan_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Less Than $1M",
				filter: "less-than-1000",
				dropdown_name: "Less Than $1M",
				search_value: "[100 TO 999999] OR last_sold_price:[100 TO 999999] OR last_listed_sale_price_all:[100 TO 999999]"
			},
			{
				name: "$1M to $2M",
				filter: "1000-to-1000",
				dropdown_name: "$1M to $2M",
				search_value: "[1000000 TO 1999999] OR last_sold_price:[1000000 TO 1999999] OR last_listed_sale_price_all:[1000000 TO 1999999]"
			},
			{
				name: "$2M to $3M",
				filter: "2000-to-3000",
				dropdown_name: "$2M to $3M",
				search_value: "[2000000 TO 2999999] OR last_sold_price:[2000000 TO 2999999] OR last_listed_sale_price_all:[2000000 TO 2999999]"
			},			{
				name: "$3M to $4M",
				filter: "3000-to-4000",
				dropdown_name: "$3M to $4M",
				search_value: "[3000000 TO 3999999] OR last_sold_price:[3000000 TO 3999999] OR last_listed_sale_price_all:[3000000 TO 3999999]"
			},
			{
				name: "$4M to $5M",
				filter: "4000-to-5000",
				dropdown_name: "$4M to $5M",
				search_value: "[4000000 TO 4999999] OR last_sold_price:[4000000 TO 4999999] OR last_listed_sale_price_all:[4000000 TO 4999999]"
			},
			{
				name: "$5M+",
				filter: "5000-or-more",
				dropdown_name: "$5M+",
				search_value: "[5000001 TO *] OR last_sold_price:[5000001 TO *] OR last_listed_sale_price_all:[5000001 TO *]"
			}
		]
	},
	{
		name: "Age of Loan",
		show_name: true,
		search_key: "loan_age",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Less Than 2 Years",
				filter: "0-to-2",
				dropdown_name: "Less Than 2 Years",
				search_value: "[0 TO 25]"
			},
			{
				name: "2 to 5 Years",
				filter: "2-to-5",
				dropdown_name: "2 to 5 Years",
				search_value: "[50 TO 79]"
			},
			{
				name: "5 to 10 Years",
				filter: "2-to-5",
				dropdown_name: "5 to 10 Years",
				search_value: "[50 TO 79]"
			},
			{
				name: "10 to 15 Years",
				filter: "2-to-5",
				dropdown_name: "10 to 15 Years",
				search_value: "[50 TO 79]"
			},
			{
				name: "15 to 20 Years",
				filter: "15-to-20",
				dropdown_name: "15 to 20 Years",
				search_value: "[50 TO 79]"
			},
			{
				name: "20 to 30 Years",
				filter: "15-to-20",
				dropdown_name: "20 to 30 Years",
				search_value: "[50 TO 79]"
			},
			{
				name: "More Than 30 Years",
				filter: "15-to-20",
				dropdown_name: "More Than 30 Years",
				search_value: "[50 TO 79]"
			},
		]
	},
	{
		name: "Property Value",
		show_name: true,
		search_key: "offering_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Less Than $1M",
				filter: "less-than-1000",
				dropdown_name: "Less Than $1M",
				search_value: "[100 TO 999999] OR last_sold_price:[100 TO 999999] OR last_listed_sale_price_all:[100 TO 999999]"
			},
			{
				name: "$1M to $2M",
				filter: "1000-to-1000",
				dropdown_name: "$1M to $2M",
				search_value: "[1000000 TO 1999999] OR last_sold_price:[1000000 TO 1999999] OR last_listed_sale_price_all:[1000000 TO 1999999]"
			},
			{
				name: "$2M to $3M",
				filter: "2000-to-3000",
				dropdown_name: "$2M to $3M",
				search_value: "[2000000 TO 2999999] OR last_sold_price:[2000000 TO 2999999] OR last_listed_sale_price_all:[2000000 TO 2999999]"
			},			{
				name: "$3M to $4M",
				filter: "3000-to-4000",
				dropdown_name: "$3M to $4M",
				search_value: "[3000000 TO 3999999] OR last_sold_price:[3000000 TO 3999999] OR last_listed_sale_price_all:[3000000 TO 3999999]"
			},
			{
				name: "$4M to $5M",
				filter: "4000-to-5000",
				dropdown_name: "$4M to $5M",
				search_value: "[4000000 TO 4999999] OR last_sold_price:[4000000 TO 4999999] OR last_listed_sale_price_all:[4000000 TO 4999999]"
			},
			{
				name: "$5M+",
				filter: "5000-or-more",
				dropdown_name: "$5M+",
				search_value: "[5000001 TO *] OR last_sold_price:[5000001 TO *] OR last_listed_sale_price_all:[5000001 TO *]"
			}
		]
	}
]

export const _buildingComingSoonFilters = [
	{
		name: "Borough",
		show_name: true,
		default_name: 'All Boroughs',
		search_key: "borough",
		values: [
			{
				name: "All Boroughs",
				filter: "",
				dropdown_name: "All Boroughs",
				search_value: ""
			},
			{
				name: "Manhattan",
				filter: "manhattan",
				dropdown_name: "Manhattan",
				search_value: "manhattan",
			},
			{
				name: "Brooklyn",
				filter: "brooklyn",
				dropdown_name: "Brooklyn",
				search_value: "brooklyn",
			},
			{
				name: "Queens",
				filter: "queens",
				dropdown_name: "Queens",
				search_value: "queens",
			},
		]
	},
	{
		name: "Construction",
		show_name: true,
		search_key: "sales_start_date",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Move-in Ready",
				filter: "completed",
				dropdown_name: "Move-in Ready",
				search_value: " * AND building_effective_start:[NOW-25YEARS TO NOW]",
			},
			{
				name: "Under Construction",
				filter: "not-completed",
				dropdown_name: "Under Construction",
				search_value: "[NOW-5YEARS TO NOW] AND -building_effective_start:[NOW-25YEARS TO NOW]",
			}
			
		]
	},	
	{
		name: "Price / Sq Ft",
		show_name: true,
		search_key: "inventory_stats_listings_average_ppsf",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "< $750 PPSF ",
				filter: "less-than-750",
				dropdown_name: "Less than $750",
				search_value: "[100 TO 750]"
			},
			{
				name: "$750 to $1,000 PPSF",
				filter: "75-to-1000",
				dropdown_name: "$750 to $1,000",
				search_value: "[751 TO 1000]"
			},
			{
				name: "$1,000 to $1,500 PPSF",
				filter: "1000-to-1500",
				dropdown_name: "$1,000 to $1,500",
				search_value: "[1001 TO 1500]"
			},
			{
				name: "$1,500 to $2,000 PPSF",
				filter: "1500-to-2000",
				dropdown_name: "$1,500 to $2,000",
				search_value: "[1500 TO 2000]"
			},
			{
				name: "$2,000 to $2,500 PPSF",
				filter: "2000-to-2500",
				dropdown_name: "$2,000 to $2,500",
				search_value: "[2001 to 2500]"
			},
			{
				name: "$2,500 to $5,000 PPSF",
				filter: "2500-to-5000",
				dropdown_name: "$2,500 to $5,000",
				search_value: "[2501 to 5000]"
			},
			{
				name: "$5,000+ PPSF",
				filter: "5000-or-more",
				dropdown_name: "$5,000 or more",
				search_value: "[5001 TO *]"
			}
		]
	},
	{
		name: "Starting From",
		show_name: true,
		search_key: "inventory_stats_listings_low_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "From: < $500,000 ",
				filter: "less-than-500",
				dropdown_name: "Less than $500K",
				search_value: "[100 TO 500000]"
			},
			{
				name: "From: $500K to $750K",
				filter: "500-to-750",
				dropdown_name: "$500K to $750K",
				search_value: "[500000 TO 750000]"
			},
			{
				name: "From: $750K to $1M",
				filter: "750-to-1000",
				dropdown_name: "$750K to $1M",
				search_value: "[750001 TO 1000000]"
			},
			{
				name: "From: $1M to $1.5M",
				filter: "1000-to-1500",
				dropdown_name: "$1M to $1.5M",
				search_value: "[1000001 TO 1500000]"
			},
			{
				name: "From: $1.5M to $2M",
				filter: "1500-to-2000",
				dropdown_name: "$1.5M to $2M",
				search_value: "[1500001 TO 2000000]"
			},
			{
				name: "From: $2M+",
				filter: "2000+",
				dropdown_name: "$2M+",
				search_value: "[2000000 TO *]"
			}
		]
	},
	
	{
		name: "Unsold Units",
		show_name: true,
		search_key: "inventory_unsold",
		values: [
			{
				name: "Any Unsold Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-10 Unsold Units",
				filter: "1-to-10",
				dropdown_name: "1 to 10",
				search_value: "[1 TO 10]"
			},
			{
				name: "11-30 Unsold Units",
				filter: "11-to-30",
				dropdown_name: "11 to 30",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Unsold Units",
				filter: "31-to-50",
				dropdown_name: "31 to 50",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Unsold Units",
				filter: "51-to-100",
				dropdown_name: "51 to 100",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Unsold Units",
				filter: "101-to-200",
				dropdown_name: "101 to 200",
				search_value: "[101 TO 200]"
			},
			{
				name: "201 + Unsold Units",
				filter: "201-or-more",
				dropdown_name: "201 or more",
				search_value: "[201 TO *]"
			}
		]
	},
	{
		name: "% Sold",
		show_name: true,
		search_key: "inventory_pct_sold",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Has Sales",
				filter: "has-sales",
				dropdown_name: "Has Sales",
				search_value: "[1 TO *] OR offering_verified_status:\"sold out\""
			},
			{
				name: "Has No Sales",
				filter: "no-sales",
				dropdown_name: "Has No Sales",
				search_value: "[* TO 0] AND -offering_verified_status:\"sold out\""
			},
			{
				name: "Less Than 15%",
				filter: "0-to-15",
				dropdown_name: "Less Than 15%",
				search_value: "[0 TO 15]"
			},
			{
				name: "Less Than 35%",
				filter: "0-to-35",
				dropdown_name: "Less Than 35%",
				search_value: "[0 TO 34]"
			},
			{
				name: "Less Than 50%",
				filter: "0-to-49",
				dropdown_name: "Less Than 50%",
				search_value: "[0 TO 49]"
			},
			{
				name: "50% to 79%",
				filter: "50-to-79",
				dropdown_name: "50% to 79%",
				search_value: "[50 TO 79]"
			},
			{
				name: "80% to 99%",
				filter: "80-to-99",
				dropdown_name: "80% to 99%",
				search_value: "[80 TO 99]"
			},
			{
				name: "Sold Out",
				filter: "100 TO *",
				dropdown_name: "Sold Out",
				search_value: "[100 TO *]"
			},
			{
				name: "More Than 15%",
				filter: "15-to-100",
				dropdown_name: "More Than 15%",
				search_value: "[15 TO *]"
			},
			{
				name: "More Than 35%",
				filter: "35-to-100",
				dropdown_name: "More Than 35%",
				search_value: "[35 TO *]"
			},
			{
				name: "More Than 50%",
				filter: "50-to-100",
				dropdown_name: "More Than 50%",
				search_value: "[50 TO *]"
			},
		]
	},
	{
		name: "Building Size",
		show_name: true,
		search_key: "residential_units",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-10 Total Units",
				filter: "1-to-10",
				dropdown_name: "1 to 10 Units",
				search_value: "[1 TO 10]"
			},
			{
				name: "11-30 Total Units",
				filter: "11-to-30",
				dropdown_name: "11 to 30 Units",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Total Units",
				filter: "31-to-50",
				dropdown_name: "31 to 50 Units",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Total Units",
				filter: "51-to-100",
				dropdown_name: "51 to 100 Units",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Total Units",
				filter: "101-to-200",
				dropdown_name: "101 to 200 Units",
				search_value: "[101 TO 200]"
			},
			{
				name: "201 + Total Units",
				filter: "201-or-more",
				dropdown_name: "201 or more Units",
				search_value: "[201 TO *]"
			}
		]
	},
	{
		name: "Status",
		show_name: true,
		search_key: "offering_verified_status",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Coming Soon",
				filter: "coming-soon",
				dropdown_name: "Coming Soon",
				search_value: '("coming soon")'
			},
			{
				name: "Submit Offering Plan",
				filter: "submit-offering-plan",
				dropdown_name: "Submit Offering Plan",
				search_value: '("offering plan required")'
			},
			{
				name: "Condo Dec Vetted",
				filter: "condo-dec-vetted",
				dropdown_name: "Condo Dec Vetted",
				search_value: '("condo declaration vetted")'
			},
		]
	}	
];


export const _buildingAdminFilters = [
	/*{
		name: "Borough",
		show_name: true,
		default_name: 'All Boroughs',
		search_key: "borough",
		values: [
			{
				name: "All Boroughs",
				filter: "",
				dropdown_name: "All Boroughs",
				search_value: ""
			},
			{
				name: "Manhattan",
				filter: "manhattan",
				dropdown_name: "Manhattan",
				search_value: "manhattan",
			},
			{
				name: "Brooklyn",
				filter: "brooklyn",
				dropdown_name: "Brooklyn",
				search_value: "brooklyn",
			},
			{
				name: "Queens",
				filter: "queens",
				dropdown_name: "Queens",
				search_value: "queens",
			},
			{
				name: "Bronx",
				filter: "bronx",
				dropdown_name: "Bronx",
				search_value: "bronx",
			},
			{
				name: "Staten Island",
				filter: "staten-island",
				dropdown_name: "Staten Island",
				search_value: "staten-island",
			},
		]
	},*/
	/*{
		name: "Building Stage",
		show_name: true,
		search_key: "building_status",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Pipeline",
				filter: "pipeline",
				dropdown_name: "Pipeline",
				search_value: "pipeline",
			},
			{
				name: "Sponsor Sale",
				filter: "sponsor",
				dropdown_name: "Sponsor Sale",
				search_value: "sponsor",
			},
			{
				name: "Resale",
				filter: "resale",
				dropdown_name: "Resale",
				search_value: "resale",
			}
			
		]
	},*/
	{
		name: "Construction",
		show_name: true,
		search_key: "building_effective_start",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Move-in Ready",
				filter: "completed",
				dropdown_name: "Move-in Ready (Has CO/TCO)",
				search_value: "[NOW-25YEARS TO NOW] OR building_status:(resale) OR offering_verified_status:(\"sold out\")",
			},
			{
				name: "Under Construction",
				filter: "not-completed",
				dropdown_name: "Under Construction (No CO/TCO)",
				search_value: "[* TO NOW-25YEARS] AND -building_status:(resale) AND -offering_verified_status:(\"sold out\")",
			}
			
		]
	},
	{
		name: "Total Units",
		show_name: true,
		search_key: "residential_units",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-10 Total Units",
				filter: "1-to-10",
				dropdown_name: "1 to 10 Units",
				search_value: "[1 TO 10]"
			},
			{
				name: "11-30 Total Units",
				filter: "11-to-30",
				dropdown_name: "11 to 30 Units",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Total Units",
				filter: "31-to-50",
				dropdown_name: "31 to 50 Units",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Total Units",
				filter: "51-to-100",
				dropdown_name: "51 to 100 Units",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Total Units",
				filter: "101-to-200",
				dropdown_name: "101 to 200 Units",
				search_value: "[101 TO 200]"
			},
			{
				name: "201 + Total Units",
				filter: "201-or-more",
				dropdown_name: "201 or more Units",
				search_value: "[201 TO *]"
			}
		]
	},
	{
		name: "Unsold Units",
		show_name: true,
		exclude_stage: ["pipeline"],
		search_key: "inventory_unsold",
		values: [
			{
				name: "Any Unsold Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-10 Unsold Units",
				filter: "1-to-10",
				dropdown_name: "1 to 10",
				search_value: "[1 TO 10]"
			},
			{
				name: "11-30 Unsold Units",
				filter: "11-to-30",
				dropdown_name: "11 to 30",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Unsold Units",
				filter: "31-to-50",
				dropdown_name: "31 to 50",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Unsold Units",
				filter: "51-to-100",
				dropdown_name: "51 to 100",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Unsold Units",
				filter: "101-to-200",
				dropdown_name: "101 to 200",
				search_value: "[101 TO 200]"
			},
			{
				name: "201 + Unsold Units",
				filter: "201-or-more",
				dropdown_name: "201 or more",
				search_value: "[201 TO *]"
			}
		]
	},
	{
		name: "% Sold",
		show_name: true,
		exclude_stage: ["pipeline"],
		search_key: "inventory_pct_sold",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Has Sales",
				filter: "has-sales",
				dropdown_name: "Has Sales",
				search_value: "[1 TO *] OR offering_verified_status:\"sold out\""
			},
			{
				name: "Has No Sales",
				filter: "no-sales",
				dropdown_name: "Has No Sales",
				search_value: "[* TO 0] AND -offering_verified_status:\"sold out\""
			},
			{
				name: "Less Than 15%",
				filter: "0-to-15",
				dropdown_name: "Less Than 15%",
				search_value: "[0 TO 15]"
			},
			{
				name: "Less Than 35%",
				filter: "0-to-35",
				dropdown_name: "Less Than 35%",
				search_value: "[0 TO 34]"
			},
			{
				name: "Less Than 50%",
				filter: "0-to-49",
				dropdown_name: "Less Than 50%",
				search_value: "[0 TO 49]"
			},
			{
				name: "50% to 79%",
				filter: "50-to-79",
				dropdown_name: "50% to 79%",
				search_value: "[50 TO 79]"
			},
			{
				name: "80% to 99%",
				filter: "80-to-99",
				dropdown_name: "80% to 99%",
				search_value: "[80 TO 99]"
			},
			{
				name: "Sold Out",
				filter: "100 TO *",
				dropdown_name: "Sold Out",
				search_value: "[100 TO *]"
			}
		]
	},
	/*{
		name: "Building Stage",
		show_name: true,
		search_key: "state",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Pipeline",
				filter: "pipeline",
				dropdown_name: "Pipeline",
				search_value: "* AND offering_submitted_date:[NOW-25YEARS TO NOW] AND offering_accepted_date:[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z] AND -offering_verified_status:(\"sold out\")",
			},
			{
				name: "Sponsor Sale",
				filter: "sponsor",
				dropdown_name: "Sponsor Sale",
				search_value: "* AND offering_accepted_date:[NOW-25YEARS TO NOW] AND inventory_resale:[* TO 0] AND -offering_verified_status:(\"sold out\")",
			},
			{
				name: "Resale",
				filter: "resale",
				dropdown_name: "Resale",
				search_value: "* AND offering_effective_date:[NOW-25YEARS TO NOW] AND (inventory_resale:[1 TO *] OR offering_verified_status:(\"sold out\"))",
			}
			
		]
	},*/
	
	
	{
		name: "Price / Sq Ft",
		show_name: true,
		search_key: "inventory_stats_listings_average_ppsf",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "< $750 PPSF ",
				filter: "less-than-750",
				dropdown_name: "Less than $750",
				search_value: "[100 TO 750]"
			},
			{
				name: "$750 to $1,000 PPSF",
				filter: "75-to-1000",
				dropdown_name: "$750 to $1,000",
				search_value: "[751 TO 1000]"
			},
			{
				name: "$1,000 to $1,500 PPSF",
				filter: "1000-to-1500",
				dropdown_name: "$1,000 to $1,500",
				search_value: "[1001 TO 1500]"
			},
			{
				name: "$1,500 to $2,000 PPSF",
				filter: "1500-to-2000",
				dropdown_name: "$1,500 to $2,000",
				search_value: "[1500 TO 2000]"
			},
			{
				name: "$2,000 to $2,500 PPSF",
				filter: "2000-to-2500",
				dropdown_name: "$2,000 to $2,500",
				search_value: "[2001 to 2500]"
			},
			{
				name: "$2,500 to $5,000 PPSF",
				filter: "2500-to-5000",
				dropdown_name: "$2,500 to $5,000",
				search_value: "[2501 to 5000]"
			},
			{
				name: "$5,000+ PPSF",
				filter: "5000-or-more",
				dropdown_name: "$5,000 or more",
				search_value: "[5001 TO *]"
			}
		]
	},
	{
		name: "Starting From",
		show_name: true,
		search_key: "inventory_stats_listings_low_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "From: < $500,000 ",
				filter: "less-than-500",
				dropdown_name: "Less than $500K",
				search_value: "[100 TO 500000]"
			},
			{
				name: "From: $500K to $750K",
				filter: "500-to-750",
				dropdown_name: "$500K to $750K",
				search_value: "[500000 TO 750000]"
			},
			{
				name: "From: $750K to $1M",
				filter: "750-to-1000",
				dropdown_name: "$750K to $1M",
				search_value: "[750001 TO 1000000]"
			},
			{
				name: "From: $1M to $1.5M",
				filter: "1000-to-1500",
				dropdown_name: "$1M to $1.5M",
				search_value: "[1000001 TO 1500000]"
			},
			{
				name: "From: $1.5M to $2M",
				filter: "1500-to-2000",
				dropdown_name: "$1.5M to $2M",
				search_value: "[1500001 TO 2000000]"
			},
			{
				name: "From: $2M+",
				filter: "2000+",
				dropdown_name: "$2M+",
				search_value: "[2000000 TO *]"
			}
		]
	},
	
	
	
	{
		name: "Offering Type",
		show_name: true,
		search_key: "offering_construction",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "New Construction",
				filter: "new-construction",
				dropdown_name: "New Construction",
				search_value: "new",
			},
			{
				name: "Conversion",
				filter: "conversion",
				dropdown_name: "Conversion",
				search_value: "conversion",
			},			
			{
				name: "Rehab",
				filter: "rehab",
				dropdown_name: "Rehab",
				search_value: "rehab",
			},
			{
				name: "Exclude Conversion",
				filter: "exclude-conversion",
				dropdown_name: "Exclude Conversion",
				search_value: "(new rehab \"\")",
			}
			
		]
	},
	{
		name: "Ownership",
		show_name: true,
		search_key: "offering_plan_type",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Condo",
				filter: "condo",
				dropdown_name: "Condo",
				search_value: "condominium",
			},
			{
				name: "Co-op",
				filter: "co-op",
				dropdown_name: "Co-op",
				search_value: "cooperative",
			}
			
		]
	},
	{
		name: "Condo Dec",
		show_name: true,
		exclude_stage: ["pipeline"],
		search_key: "cdec_date",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "No Condo Dec",
				filter: "no-cdec",
				dropdown_name: "No Condo Dec",
				search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
			},
			{
				name: "Has Condo Dec",
				filter: "has-cdec",
				dropdown_name: "Has Condo Dec",
				search_value: "[NOW-15YEARS TO NOW]",
			}		
		]
	},
	{
		name: "Sales Started",
		show_name: true,
		exclude_stage: ["pipeline"],
		search_key: "sales_start_date",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Not Started",
				filter: "not-started",
				dropdown_name: "Not Started",
				search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
			},
			{
				name: "Has Started",
				filter: "has-started",
				dropdown_name: "Has Started",
				search_value: "[NOW-15YEARS TO NOW]",
			},
			{
				name: "Within 1 Year",
				filter: "1-year",
				dropdown_name: "Within 1 Year",
				search_value: "[NOW-1YEARS TO NOW]",
			},
			{
				name: "1 to 2 Years",
				filter: "2-year",
				dropdown_name: "Last 1 to 2 Years",
				search_value: "[NOW-2YEARS TO NOW-1YEARS]",
			},
			{
				name: "2 to 5 Years",
				filter: "2-5-year",
				dropdown_name: "Last 2 to 5 Years",
				search_value: "[NOW-5YEARS TO NOW-2YEARS]",
			},
			{
				name: "More Than 5 Years",
				filter: "more-5-year",
				dropdown_name: "More Than 5 Years Ago",
				search_value: "[NOW-15YEARS TO NOW-5YEARS]",
			}			
		]
	},
	{
		name: "Last Listing",
		show_name: true,
		exclude_stage: ["pipeline"],
		search_key: "last_listed_sale_date_formatted",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "No Activity",
				filter: "no-activity",
				dropdown_name: "No Activity",
				search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z] AND -building_status:resale AND -offering_verified_status:\"sold out\"",
			},
			{
				name: "Any Activity",
				filter: "any-activity",
				dropdown_name: "Any Activity",
				search_value: "[NOW-15YEARS TO NOW] OR offering_verified_status:\"sold out\" OR building_status:resale",
			},
			{
				name: "Within 1 Year",
				filter: "1-year",
				dropdown_name: "Within 1 Year",
				search_value: "[NOW-1YEARS TO NOW]",
			},
			{
				name: "1 to 2 Years",
				filter: "2-year",
				dropdown_name: "Last 1 to 2 Years",
				search_value: "[NOW-2YEARS TO NOW-1YEARS]",
			},
			{
				name: "2 to 5 Years",
				filter: "2-5-year",
				dropdown_name: "Last 2 to 5 Years",
				search_value: "[NOW-5YEARS TO NOW-2YEARS]",
			},
			{
				name: "More Than 5 Years",
				filter: "more-5-year",
				dropdown_name: "More Than 5 Years Ago",
				search_value: "[NOW-15YEARS TO NOW-5YEARS]",
			}			
		]
	},
	{
		name: "Last Contract",
		show_name: true,
		exclude_stage: ["pipeline"],
		search_key: "last_contract_date_formatted",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "No Activity",
				filter: "no-activity",
				dropdown_name: "No Activity",
				search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z] AND -building_status:resale AND -offering_verified_status:\"sold out\" AND -inventory_sold:[1 TO *] AND -inventory_contract:[1 TO *]",
			},
			{
				name: "Any Activity",
				filter: "any-activity",
				dropdown_name: "Any Activity",
				search_value: "[NOW-15YEARS TO NOW] OR offering_verified_status:\"sold out\" OR building_status:resale",
			},
			{
				name: "Within 1 Year",
				filter: "1-year",
				dropdown_name: "Within 1 Year",
				search_value: "[NOW-1YEARS TO NOW]",
			},
			{
				name: "1 to 2 Years",
				filter: "2-year",
				dropdown_name: "Last 1 to 2 Years",
				search_value: "[NOW-2YEARS TO NOW-1YEARS]",
			},
			{
				name: "2 to 5 Years",
				filter: "2-5-year",
				dropdown_name: "Last 2 to 5 Years",
				search_value: "[NOW-5YEARS TO NOW-2YEARS]",
			},
			{
				name: "More Than 5 Years",
				filter: "more-5-year",
				dropdown_name: "More Than 5 Years Ago",
				search_value: "[NOW-15YEARS TO NOW-5YEARS]",
			}			
		]
	},
	{
		name: "Last Sale",
		show_name: true,
		exclude_stage: ["pipeline"],
		search_key: "last_sold_date_formatted",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "No Activity",
				filter: "no-activity",
				dropdown_name: "No Activity",
				search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z] AND -offering_verified_status:\"sold out\" AND inventory_sold:[* TO 0]",
			},
			{
				name: "Any Activity",
				filter: "any-activity",
				dropdown_name: "Any Activity",
				search_value: "[NOW-15YEARS TO NOW] OR offering_verified_status:\"sold out\"",
			},
			{
				name: "Within 1 Year",
				filter: "1-year",
				dropdown_name: "Within 1 Year",
				search_value: "[NOW-1YEARS TO NOW]",
			},
			{
				name: "1 to 2 Years",
				filter: "2-year",
				dropdown_name: "Last 1 to 2 Years",
				search_value: "[NOW-2YEARS TO NOW-1YEARS]",
			},
			{
				name: "2 to 5 Years",
				filter: "2-5-year",
				dropdown_name: "Last 2 to 5 Years",
				search_value: "[NOW-5YEARS TO NOW-2YEARS]",
			},
			{
				name: "More Than 5 Years",
				filter: "more-5-year",
				dropdown_name: "More Than 5 Years Ago",
				search_value: "[NOW-15YEARS TO NOW-5YEARS]",
			}			
		]
	},
	{
		name: "Offering Status",
		show_name: true,
		admin_only: true,
		search_key: "offering_submitted_date",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "All Submitted",
				filter: "submitted",
				dropdown_name: "All Submitted",
				search_value: "[NOW-25YEARS TO NOW]",
			},
			{
				name: "All Accepted",
				filter: "accepted",
				dropdown_name: "All Accepted",
				search_value: "[NOW-25YEARS TO NOW] AND offering_accepted_date:[NOW-25YEARS TO NOW]",
			},
			{
				name: "All Effective",
				filter: "effective",
				dropdown_name: "All Effective",
				search_value: "[NOW-25YEARS TO NOW] AND offering_effective_date:[NOW-25YEARS TO NOW]",
			},
			{
				name: "Only Submitted",
				filter: "submitted-only",
				dropdown_name: "Only Submitted",
				search_value: "[NOW-25YEARS TO NOW] AND offering_accepted_date:[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
			},
			{
				name: "Only Accepted",
				filter: "accepted-only",
				dropdown_name: "Only Accepted",
				search_value: "[NOW-25YEARS TO NOW] AND offering_accepted_date:[NOW-25YEARS TO NOW] AND offering_effective_date:[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
			},
			{
				name: "Only Effectiv Only",
				filter: "effective-only",
				dropdown_name: "Only Effective",
				search_value: "[NOW-25YEARS TO NOW] AND offering_effective_date:[NOW-25YEARS TO NOW]",
			}
			
		]
	},
	{
		name: "Status",
		show_name: true,
		search_key: "offering_verified_status",
		admin_only: true,
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Monitoring",
				filter: "monitoring",
				dropdown_name: "Monitoring",
				search_value: 'monitoring'
			},
			{
				name: "Reviewed",
				filter: "reviewed",
				dropdown_name: "Reviewed",
				search_value: 'reviewed'
			},
			{
				name: "Requesting Offering Plan",
				filter: "offering-plan-requested",
				dropdown_name: "Requesting Offering Plan",
				search_value: '("offering plan required")'
			},
			{
				name: "Condo Dec Vetted",
				filter: "condo-dec-vetted",
				dropdown_name: "Condo Dec Vetted",
				search_value: '("condo declaration vetted")'
			},
			{
				name: "Vetting Required",
				filter: "vetting-required",
				dropdown_name: "Vetting Required",
				search_value: '("vetting required")'
			},
			{
				name: "Vetted",
				filter: "vetted",
				dropdown_name: "Vetted",
				search_value: "vetted"
			},
			{
				name: "Coming Soon",
				filter: "coming-soon",
				dropdown_name: "Coming Soon",
				search_value: '("coming soon")'
			},
			{
				name: "Active",
				filter: "active",
				dropdown_name: "Active",
				search_value: 'active'
			},
			{
				name: "Abandoned",
				filter: "abandoned",
				dropdown_name: "Abandoned",
				search_value: "abandoned"
			},
			{
				name: "Not Abandoned",
				filter: "not-abandoned",
				dropdown_name: "Not Abandoned",
				search_value: '("" "monitoring" "reviewed" "offering plan required" "condo declaration vetted" "vetting required" "vetted" "coming soon" "active" "sold out")'
			},			
			{
				name: "Sold Out",
				filter: "sold-out",
				dropdown_name: "Sold Out",
				search_value: '("sold out")'
			},
			{
				name: "Excluded",
				filter: "excluded",
				dropdown_name: "Excluded",
				search_value: "excluded"
			},

		]
	},	
/*	{
		name: "Total Financed",
		show_name: true,
		search_key: "total_loan_amount",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "< $5M",
				filter: "less-than-5m",
				dropdown_name: "Less than $5M",
				search_value: "[0 TO 5000000]"
			},
			{
				name: "$5M to $10M",
				filter: "5-to-10",
				dropdown_name: "$5M to $10M",
				search_value: "[5000000 TO 10000000]"
			},
			{
				name: "$10M to $25M",
				filter: "10-to-25",
				dropdown_name: "$10M to $25M",
				search_value: "[10000000 TO 25000000]"
			},
			{
				name: "$25M to $50M",
				filter: "25-to-50",
				dropdown_name: "$25M to $50M",
				search_value: "[25000000 TO 50000000]"
			},
			{
				name: "$50M to $100M",
				filter: "50-to-100",
				dropdown_name: "$50M to $100M",
				search_value: "[50000000 TO 100000000]"
			},
			{
				name: "$100M to $250M",
				filter: "100-to-250",
				dropdown_name: "$100M to $250M",
				search_value: "[100000000 TO 250000000]"
			},
			{
				name: "$250M to $500M",
				filter: "250-to-500",
				dropdown_name: "$250M to $500M",
				search_value: "[250000000 TO 500000000]"
			},
			{
				name: "$500M to $1B",
				filter: "500-to-1b",
				dropdown_name: "$500M to $1B",
				search_value: "[500000000 TO 1000000000]"
			},

			{
				name: "$1B+",
				filter: "1b-or-more",
				dropdown_name: "$1B or more",
				search_value: "[1000000000 TO *]"
			}
		]
	},*/

];

export const _marketActivityFilters = [
	
	{
		name: "Construction",
		show_name: true,
		search_key: "building_effective_start",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Move-in Ready",
				filter: "completed",
				dropdown_name: "Move-in Ready (Has CO/TCO)",
				search_value: "[NOW-25YEARS TO NOW] OR building_status:(resale) OR offering_verified_status:(\"sold out\")",
			},
			{
				name: "Under Construction",
				filter: "not-completed",
				dropdown_name: "Under Construction (No CO/TCO)",
				search_value: "[* TO NOW-25YEARS] AND -building_status:(resale) AND -offering_verified_status:(\"sold out\")",
			}
			
		]
	},
	{
		name: "Total Units",
		show_name: true,
		search_key: "residential_units",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-10 Total Units",
				filter: "1-to-10",
				dropdown_name: "1 to 10 Units",
				search_value: "[1 TO 10]"
			},
			{
				name: "11-30 Total Units",
				filter: "11-to-30",
				dropdown_name: "11 to 30 Units",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Total Units",
				filter: "31-to-50",
				dropdown_name: "31 to 50 Units",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Total Units",
				filter: "51-to-100",
				dropdown_name: "51 to 100 Units",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Total Units",
				filter: "101-to-200",
				dropdown_name: "101 to 200 Units",
				search_value: "[101 TO 200]"
			},
			{
				name: "201 + Total Units",
				filter: "201-or-more",
				dropdown_name: "201 or more Units",
				search_value: "[201 TO *]"
			}
		]
	},
	{
		name: "Unsold Units",
		show_name: true,
		exclude_stage: ["pipeline"],
		search_key: "inventory_unsold",
		values: [
			{
				name: "Any Unsold Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-10 Unsold Units",
				filter: "1-to-10",
				dropdown_name: "1 to 10",
				search_value: "[1 TO 10]"
			},
			{
				name: "11-30 Unsold Units",
				filter: "11-to-30",
				dropdown_name: "11 to 30",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Unsold Units",
				filter: "31-to-50",
				dropdown_name: "31 to 50",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Unsold Units",
				filter: "51-to-100",
				dropdown_name: "51 to 100",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Unsold Units",
				filter: "101-to-200",
				dropdown_name: "101 to 200",
				search_value: "[101 TO 200]"
			},
			{
				name: "201 + Unsold Units",
				filter: "201-or-more",
				dropdown_name: "201 or more",
				search_value: "[201 TO *]"
			}
		]
	},
	{
		name: "% Sold",
		show_name: true,
		exclude_stage: ["pipeline"],
		search_key: "inventory_pct_sold",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Has Sales",
				filter: "has-sales",
				dropdown_name: "Has Sales",
				search_value: "[1 TO *] OR offering_verified_status:\"sold out\""
			},
			{
				name: "Has No Sales",
				filter: "no-sales",
				dropdown_name: "Has No Sales",
				search_value: "[* TO 0] AND -offering_verified_status:\"sold out\""
			},
			{
				name: "Less Than 15%",
				filter: "0-to-15",
				dropdown_name: "Less Than 15%",
				search_value: "[0 TO 15]"
			},
			{
				name: "Less Than 35%",
				filter: "0-to-35",
				dropdown_name: "Less Than 35%",
				search_value: "[0 TO 34]"
			},
			{
				name: "Less Than 50%",
				filter: "0-to-49",
				dropdown_name: "Less Than 50%",
				search_value: "[0 TO 49]"
			},
			{
				name: "50% to 79%",
				filter: "50-to-79",
				dropdown_name: "50% to 79%",
				search_value: "[50 TO 79]"
			},
			{
				name: "80% to 99%",
				filter: "80-to-99",
				dropdown_name: "80% to 99%",
				search_value: "[80 TO 99]"
			},
			{
				name: "Sold Out",
				filter: "100 TO *",
				dropdown_name: "Sold Out",
				search_value: "[100 TO *]"
			}
		]
	},

	
	
	{
		name: "Price / Sq Ft",
		show_name: true,
		search_key: "inventory_stats_listings_average_ppsf",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "< $750 PPSF ",
				filter: "less-than-750",
				dropdown_name: "Less than $750",
				search_value: "[100 TO 750]"
			},
			{
				name: "$750 to $1,000 PPSF",
				filter: "75-to-1000",
				dropdown_name: "$750 to $1,000",
				search_value: "[751 TO 1000]"
			},
			{
				name: "$1,000 to $1,500 PPSF",
				filter: "1000-to-1500",
				dropdown_name: "$1,000 to $1,500",
				search_value: "[1001 TO 1500]"
			},
			{
				name: "$1,500 to $2,000 PPSF",
				filter: "1500-to-2000",
				dropdown_name: "$1,500 to $2,000",
				search_value: "[1500 TO 2000]"
			},
			{
				name: "$2,000 to $2,500 PPSF",
				filter: "2000-to-2500",
				dropdown_name: "$2,000 to $2,500",
				search_value: "[2001 to 2500]"
			},
			{
				name: "$2,500 to $5,000 PPSF",
				filter: "2500-to-5000",
				dropdown_name: "$2,500 to $5,000",
				search_value: "[2501 to 5000]"
			},
			{
				name: "$5,000+ PPSF",
				filter: "5000-or-more",
				dropdown_name: "$5,000 or more",
				search_value: "[5001 TO *]"
			}
		]
	},
	{
		name: "Starting From",
		show_name: true,
		search_key: "inventory_stats_listings_low_price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "From: < $500,000 ",
				filter: "less-than-500",
				dropdown_name: "Less than $500K",
				search_value: "[100 TO 500000]"
			},
			{
				name: "From: $500K to $750K",
				filter: "500-to-750",
				dropdown_name: "$500K to $750K",
				search_value: "[500000 TO 750000]"
			},
			{
				name: "From: $750K to $1M",
				filter: "750-to-1000",
				dropdown_name: "$750K to $1M",
				search_value: "[750001 TO 1000000]"
			},
			{
				name: "From: $1M to $1.5M",
				filter: "1000-to-1500",
				dropdown_name: "$1M to $1.5M",
				search_value: "[1000001 TO 1500000]"
			},
			{
				name: "From: $1.5M to $2M",
				filter: "1500-to-2000",
				dropdown_name: "$1.5M to $2M",
				search_value: "[1500001 TO 2000000]"
			},
			{
				name: "From: $2M+",
				filter: "2000+",
				dropdown_name: "$2M+",
				search_value: "[2000000 TO *]"
			}
		]
	},
	{
		name: "Offering Type",
		show_name: true,
		search_key: "offering_construction",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "New Construction",
				filter: "new-construction",
				dropdown_name: "New Construction",
				search_value: "new",
			},
			{
				name: "Conversion",
				filter: "conversion",
				dropdown_name: "Conversion",
				search_value: "conversion",
			},			
			{
				name: "Rehab",
				filter: "rehab",
				dropdown_name: "Rehab",
				search_value: "rehab",
			},
			{
				name: "Exclude Conversion",
				filter: "exclude-conversion",
				dropdown_name: "Exclude Conversion",
				search_value: "(new rehab \"\")",
			}
			
		]
	},
	
	{
		name: "Ownership",
		show_name: true,
		search_key: "offering_plan_type",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Condo",
				filter: "condo",
				dropdown_name: "Condo",
				search_value: "condominium",
			},
			{
				name: "Co-op",
				filter: "co-op",
				dropdown_name: "Co-op",
				search_value: "cooperative",
			}
			
		]
	},
	{
		name: "Condo Dec",
		show_name: true,
		exclude_stage: ["pipeline"],
		search_key: "cdec_date",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "No Condo Dec",
				filter: "no-cdec",
				dropdown_name: "No Condo Dec",
				search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
			},
			{
				name: "Has Condo Dec",
				filter: "has-cdec",
				dropdown_name: "Has Condo Dec",
				search_value: "[NOW-15YEARS TO NOW]",
			}		
		]
	},

	{
		name: "Sales Started",
		show_name: true,
		admin_only: true,
		exclude_stage: ["pipeline"],
		search_key: "sales_start_date",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Not Started",
				filter: "not-started",
				dropdown_name: "Not Started",
				search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
			},
			{
				name: "Has Started",
				filter: "has-started",
				dropdown_name: "Has Started",
				search_value: "[NOW-15YEARS TO NOW]",
			},
			{
				name: "Within 1 Year",
				filter: "1-year",
				dropdown_name: "Within 1 Year",
				search_value: "[NOW-1YEARS TO NOW]",
			},
			{
				name: "1 to 2 Years",
				filter: "2-year",
				dropdown_name: "Last 1 to 2 Years",
				search_value: "[NOW-2YEARS TO NOW-1YEARS]",
			},
			{
				name: "2 to 5 Years",
				filter: "2-5-year",
				dropdown_name: "Last 2 to 5 Years",
				search_value: "[NOW-5YEARS TO NOW-2YEARS]",
			},
			{
				name: "More Than 5 Years",
				filter: "more-5-year",
				dropdown_name: "More Than 5 Years Ago",
				search_value: "[NOW-15YEARS TO NOW-5YEARS]",
			}			
		]
	},
	{
		name: "Last Listing",
		show_name: true,
		admin_only: true,
		exclude_stage: ["pipeline"],
		search_key: "last_listed_sale_date_formatted",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "No Activity",
				filter: "no-activity",
				dropdown_name: "No Activity",
				search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
			},
			{
				name: "Any Activity",
				filter: "any-activity",
				dropdown_name: "Any Activity",
				search_value: "[NOW-15YEARS TO NOW]",
			},
			{
				name: "Within 1 Year",
				filter: "1-year",
				dropdown_name: "Within 1 Year",
				search_value: "[NOW-1YEARS TO NOW]",
			},
			{
				name: "1 to 2 Years",
				filter: "2-year",
				dropdown_name: "Last 1 to 2 Years",
				search_value: "[NOW-2YEARS TO NOW-1YEARS]",
			},
			{
				name: "2 to 5 Years",
				filter: "2-5-year",
				dropdown_name: "Last 2 to 5 Years",
				search_value: "[NOW-5YEARS TO NOW-2YEARS]",
			},
			{
				name: "More Than 5 Years",
				filter: "more-5-year",
				dropdown_name: "More Than 5 Years Ago",
				search_value: "[NOW-15YEARS TO NOW-5YEARS]",
			}			
		]
	},
	{
		name: "Last Contract",
		show_name: true,
		admin_only: true,
		exclude_stage: ["pipeline"],
		search_key: "last_contract_date_formatted",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "No Activity",
				filter: "no-activity",
				dropdown_name: "No Activity",
				search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
			},
			{
				name: "Any Activity",
				filter: "any-activity",
				dropdown_name: "Any Activity",
				search_value: "[NOW-15YEARS TO NOW]",
			},
			{
				name: "Within 1 Year",
				filter: "1-year",
				dropdown_name: "Within 1 Year",
				search_value: "[NOW-1YEARS TO NOW]",
			},
			{
				name: "1 to 2 Years",
				filter: "2-year",
				dropdown_name: "Last 1 to 2 Years",
				search_value: "[NOW-2YEARS TO NOW-1YEARS]",
			},
			{
				name: "2 to 5 Years",
				filter: "2-5-year",
				dropdown_name: "Last 2 to 5 Years",
				search_value: "[NOW-5YEARS TO NOW-2YEARS]",
			},
			{
				name: "More Than 5 Years",
				filter: "more-5-year",
				dropdown_name: "More Than 5 Years Ago",
				search_value: "[NOW-15YEARS TO NOW-5YEARS]",
			}			
		]
	},
	{
		name: "Last Sale",
		show_name: true,
		admin_only: true,
		exclude_stage: ["pipeline"],
		search_key: "last_sold_date_formatted",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "No Activity",
				filter: "no-activity",
				dropdown_name: "No Activity",
				search_value: "[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z] AND -offering_verified_status:\"sold out\"",
			},
			{
				name: "Any Activity",
				filter: "any-activity",
				dropdown_name: "Any Activity",
				search_value: "[NOW-15YEARS TO NOW] OR offering_verified_status:\"sold out\"",
			},
			{
				name: "Within 1 Year",
				filter: "1-year",
				dropdown_name: "Within 1 Year",
				search_value: "[NOW-1YEARS TO NOW]",
			},
			{
				name: "1 to 2 Years",
				filter: "2-year",
				dropdown_name: "Last 1 to 2 Years",
				search_value: "[NOW-2YEARS TO NOW-1YEARS]",
			},
			{
				name: "2 to 5 Years",
				filter: "2-5-year",
				dropdown_name: "Last 2 to 5 Years",
				search_value: "[NOW-5YEARS TO NOW-2YEARS]",
			},
			{
				name: "More Than 5 Years",
				filter: "more-5-year",
				dropdown_name: "More Than 5 Years Ago",
				search_value: "[NOW-15YEARS TO NOW-5YEARS]",
			}			
		]
	},

	{
		name: "Offering Status",
		show_name: true,
		admin_only: true,
		search_key: "offering_submitted_date",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "All Submitted",
				filter: "submitted",
				dropdown_name: "All Submitted",
				search_value: "[NOW-25YEARS TO NOW]",
			},
			{
				name: "All Accepted",
				filter: "accepted",
				dropdown_name: "All Accepted",
				search_value: "[NOW-25YEARS TO NOW] AND offering_accepted_date:[NOW-25YEARS TO NOW]",
			},
			{
				name: "All Effective",
				filter: "effective",
				dropdown_name: "All Effective",
				search_value: "[NOW-25YEARS TO NOW] AND offering_effective_date:[NOW-25YEARS TO NOW]",
			},
			{
				name: "Only Submitted",
				filter: "submitted-only",
				dropdown_name: "Only Submitted",
				search_value: "[NOW-25YEARS TO NOW] AND offering_accepted_date:[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
			},
			{
				name: "Only Accepted",
				filter: "accepted-only",
				dropdown_name: "Only Accepted",
				search_value: "[NOW-25YEARS TO NOW] AND offering_accepted_date:[NOW-25YEARS TO NOW] AND offering_effective_date:[1970-01-01T00:00:00Z TO 1970-01-02T00:00:00Z]",
			},
			{
				name: "Only Effectiv Only",
				filter: "effective-only",
				dropdown_name: "Only Effective",
				search_value: "[NOW-25YEARS TO NOW] AND offering_effective_date:[NOW-25YEARS TO NOW]",
			}
			
		]
	},
	{
		name: "Status",
		show_name: true,
		search_key: "offering_verified_status",
		admin_only: true,
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Monitoring",
				filter: "monitoring",
				dropdown_name: "Monitoring",
				search_value: 'monitoring'
			},
			{
				name: "Reviewed",
				filter: "reviewed",
				dropdown_name: "Reviewed",
				search_value: 'reviewed'
			},
			{
				name: "Requesting Offering Plan",
				filter: "offering-plan-requested",
				dropdown_name: "Requesting Offering Plan",
				search_value: '("offering plan required")'
			},
			{
				name: "Condo Dec Vetted",
				filter: "condo-dec-vetted",
				dropdown_name: "Condo Dec Vetted",
				search_value: '("condo declaration vetted")'
			},
			{
				name: "Vetting Required",
				filter: "vetting-required",
				dropdown_name: "Vetting Required",
				search_value: '("vetting required")'
			},
			{
				name: "Vetted",
				filter: "vetted",
				dropdown_name: "Vetted",
				search_value: "vetted"
			},
			{
				name: "Coming Soon",
				filter: "coming-soon",
				dropdown_name: "Coming Soon",
				search_value: '("coming soon")'
			},
			{
				name: "Active",
				filter: "active",
				dropdown_name: "Active",
				search_value: 'active'
			},
			{
				name: "Abandoned",
				filter: "abandoned",
				dropdown_name: "Abandoned",
				search_value: "abandoned"
			},
			{
				name: "Not Abandoned",
				filter: "not-abandoned",
				dropdown_name: "Not Abandoned",
				search_value: '("" "monitoring" "reviewed" "offering plan required" "condo declaration vetted" "vetting required" "vetted" "coming soon" "active" "sold out")'
			},			
			{
				name: "Sold Out",
				filter: "sold-out",
				dropdown_name: "Sold Out",
				search_value: '("sold out")'
			},
			{
				name: "Excluded",
				filter: "excluded",
				dropdown_name: "Excluded",
				search_value: "excluded"
			},

		]
	},	

];


export const _pipeLineFilter = [
	{
		name: "Borough",
		show_name: true,
		default_name: 'All Boroughs',
		search_key: "borough",
		values: [
			{
				name: "All Boroughs",
				filter: "",
				dropdown_name: "All Boroughs",
				search_value: ""
			},
			{
				name: "Manhattan",
				filter: "manhattan",
				dropdown_name: "Manhattan",
				search_value: "manhattan",
			},
			{
				name: "Brooklyn",
				filter: "brooklyn",
				dropdown_name: "Brooklyn",
				search_value: "brooklyn",
			},
			{
				name: "Queens",
				filter: "queens",
				dropdown_name: "Queens",
				search_value: "queens",
			},
			{
				name: "Bronx",
				filter: "bronx",
				dropdown_name: "Bronx",
				search_value: "bronx",
			},
			{
				name: "Staten Island",
				filter: "staten-island",
				dropdown_name: "Staten Island",
				search_value: "staten-island",
			},
		]
	},	
/*	{
		name: "Stage",
		show_name: true,
		search_key: "event_tags",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Permit Filed",
				filter: "permit-filed",
				dropdown_name: "Permit Filed",
				search_value: "permit-filing",
			},
			{
				name: "Offering Submitted",
				filter: "offering-submitted",
				dropdown_name: "Offering Submitted",
				search_value: "submitted",
			},
			{
				name: "Offering Accepted",
				filter: "offering-accepted",
				dropdown_name: "Offering Accepted",
				search_value: "accepted",
			},
			{
				name: "Offering Effective",
				filter: "offering-effective",
				dropdown_name: "Offering Effective",
				search_value: "effective",
			},
			
		]
	},	*/
	{
		name: "Planned Units",
		show_name: true,
		search_key: "units",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "3-10 Units",
				filter: "3-to-10",
				dropdown_name: "3 to 10 Units",
				search_value: "[3 TO 10]"
			},
			{
				name: "11-30 Units",
				filter: "11-to-30",
				dropdown_name: "11 to 30 Units",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Units",
				filter: "31-to-50",
				dropdown_name: "31 to 50 Units",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Units",
				filter: "51-to-100",
				dropdown_name: "51 to 100 Units",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Units",
				filter: "101-to-200",
				dropdown_name: "101 to 200 Units",
				search_value: "[101 TO 200]"
			},
			{
				name: "201 + Units",
				filter: "201-or-more",
				dropdown_name: "201 or more Units",
				search_value: "[201 TO *]"
			}
		]
	},
	{
		name: "Permit Type",
		show_name: true,
		search_key: "topic",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "New Building",
				filter: "new-building",
				dropdown_name: "New Building",
				search_value: "permits AND event_tags:nb",
			},
			{
				name: "Major Alteration",
				filter: "major-alteration",
				dropdown_name: "Major Alteration",
				search_value: "permits AND event_tags:a1",
			}
			
		]
	},
	{
		name: "Offering Type",
		show_name: true,
		search_key: "event_tags",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "New Condo",
				filter: "new-condo",
				dropdown_name: "New Condo",
				search_value: "new-condo",
			},
			{
				name: "Condo Conversion",
				filter: "condo-conversion",
				dropdown_name: "Condo Conversion",
				search_value: "condo-conversion",
			},
			{
				name: "New Co-op",
				filter: "new-coop",
				dropdown_name: "New Co-op",
				search_value: "new-coop",
			},
			{
				name: "Co-op Conversion ",
				filter: "coop-conversion",
				dropdown_name: "Co-op Conversion",
				search_value: "coop-conversion",
			},
			
		]
	},
	{
		name: "Offering Sellout",
		show_name: true,
		search_key: "price",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Under $10M",
				filter: "under-10m",
				dropdown_name: "Under $10M",
				search_value: "[* TO 10000000]"
			},
			{
				name: "$10M to $50M",
				filter: "10-to-50",
				dropdown_name: "$10M to $50M",
				search_value: "[10000000 TO 50000000]"
			},
			{
				name: "$50M to $100M",
				filter: "50-to-100",
				dropdown_name: "$50M to $100M",
				search_value: "[50000000 TO 100000000]"
			},
			{
				name: "$100M to $200M",
				filter: "100-to-200",
				dropdown_name: "$100M to $200M",
				search_value: "[100000000 TO 200000000]"
			},
			{
				name: "More Than $200M",
				filter: "more-than-200",
				dropdown_name: "More Than $200M",
				search_value: "[200000000 TO *]"
			},

			
		]
	},	
	
];


export const _buildingAdminFiltersRental = [
	{
		name: "Borough",
		show_name: true,
		default_name: 'All Boroughs',
		search_key: "borough",
		values: [
			{
				name: "All Boroughs",
				filter: "",
				dropdown_name: "All Boroughs",
				search_value: ""
			},
			{
				name: "Manhattan",
				filter: "manhattan",
				dropdown_name: "Manhattan",
				search_value: "manhattan",
			},
			{
				name: "Brooklyn",
				filter: "brooklyn",
				dropdown_name: "Brooklyn",
				search_value: "brooklyn",
			},
			{
				name: "Queens",
				filter: "queens",
				dropdown_name: "Queens",
				search_value: "queens",
			},
			{
				name: "Bronx",
				filter: "bronx",
				dropdown_name: "Bronx",
				search_value: "bronx",
			},
			{
				name: "Staten Island",
				filter: "staten-island",
				dropdown_name: "Staten Island",
				search_value: "staten-island",
			},
		]
	},
	{
		name: "Type",
		show_name: true,
		search_key: "ownership_type",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Hybrid - Condo",
				filter: "hybrid",
				dropdown_name: "Hybrid - Condo",
				search_value: "* AND ((ownership_type:*condo* AND ownership_occupancy_sub_types:*rental*) OR (ownership_occupancy_sub_types:*condo* AND ownership_type:*rental*))",
			},
			{
				name: "OP Filed",
				filter: "op-filed",
				dropdown_name: "Offering Plan Filed",
				search_value: "* AND (offering_submitted_date:[NOW-15YEARS TO NOW])",
			}
			
		]
	},
	{
		name: "Total Floors",
		show_name: true,
		search_key: "total_floors",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-5 Floors",
				filter: "1-to-10",
				dropdown_name: "1 to 5 Floors",
				search_value: "[1 TO 5]"
			},
			{
				name: "6-10 Floors",
				filter: "6-to-10",
				dropdown_name: "6 to 10 Floors",
				search_value: "[6 TO 10]"
			},
			{
				name: "11-20 Floors",
				filter: "11-to-20",
				dropdown_name: "11 to 20 Floors",
				search_value: "[11 TO 20]"
			},
			{
				name: "21-30 Floors",
				filter: "21-to-30",
				dropdown_name: "21 to 30 Floors",
				search_value: "[21 TO 30]"
			},
			{
				name: "31-40 Floors",
				filter: "31-to-40",
				dropdown_name: "31 to 40 Floors",
				search_value: "[31 TO 40]"
			},
			{
				name: "40+ Floors",
				filter: "40-or-more",
				dropdown_name: "41 or More Floors",
				search_value: "[41 TO *]"
			}
		]
	},
/*
	{
		name: "Construction",
		show_name: true,
		search_key: "building_effective_start",
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Move-in Ready",
				filter: "completed",
				dropdown_name: "Move-in Ready",
				search_value: "[NOW-15YEARS TO NOW]",
			},
			{
				name: "Under Construction",
				filter: "not-completed",
				dropdown_name: "Under Construction",
				search_value: "[* TO NOW-15YEARS]",
			}
			
		]
	},
*/
	{
		name: "Total Units",
		show_name: true,
		search_key: "residential_units",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "1-10 Total Units",
				filter: "1-to-10",
				dropdown_name: "1 to 10 Units",
				search_value: "[1 TO 10]"
			},
			{
				name: "11-30 Total Units",
				filter: "11-to-30",
				dropdown_name: "11 to 30 Units",
				search_value: "[11 TO 30]"
			},
			{
				name: "31-50 Total Units",
				filter: "31-to-50",
				dropdown_name: "31 to 50 Units",
				search_value: "[31 TO 50]"
			},
			{
				name: "51-100 Total Units",
				filter: "51-to-100",
				dropdown_name: "51 to 100 Units",
				search_value: "[51 TO 100]"
			},
			{
				name: "101-200 Total Units",
				filter: "101-to-200",
				dropdown_name: "101 to 200 Units",
				search_value: "[101 TO 200]"
			},
			{
				name: "201 + Total Units",
				filter: "201-or-more",
				dropdown_name: "201 or more Units",
				search_value: "[201 TO *]"
			}
		]
	}
];

export const _buildingStageFilter = [{
		search_key: "building_stage",
		type: "array",
		values: [
			{
				filter: "pipeline"
			},
			{
				filter: "sponsor"
			},
			{
				filter: "resale"
			},
			{
				filter: "all"
			}
			
		]
}]

export const _unitStageFilter = [{
		search_key: "unit_stage",
		type: "array",
		values: [
			{
				filter: "sponsor"
			},
			{
				filter: "resale"
			}			
		]
}]